import { render, staticRenderFns } from "./moneyBoxPage.vue?vue&type=template&id=43858da2&"
import script from "./moneyBoxPage.vue?vue&type=script&lang=ts&"
export * from "./moneyBoxPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports